import { render, staticRenderFns } from "./HospitalIntroTjxyt.vue?vue&type=template&id=5f5b303e&scoped=true"
import script from "./HospitalIntroTjxyt.vue?vue&type=script&lang=js"
export * from "./HospitalIntroTjxyt.vue?vue&type=script&lang=js"
import style0 from "./HospitalIntroTjxyt.vue?vue&type=style&index=0&id=5f5b303e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5b303e",
  null
  
)

export default component.exports